<!-- 项目文件 -->
<template>
    <div class="bg333 posre w100p pt50 pb25 textc ">
        <div class="posab left0 top-35 w100p">
            <P class="fs0 textc"><img class="w70 h70" src="../../public/img/img11.png" alt=""></P>
        </div>
        <p class="w50ph100p lh18 disinblock">
            <span class="disblock  cfff fs13 ">江苏车里车外信息技术有限公司版权所有</span>
            <span class="disblock  cfff fs13 ">苏ICP备16034047</span>
        </p>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            };
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>